var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"src":"https://www.dmm.com/images/netgame/navi/dmm_logo.gif","alt":"DMM.com"}})])}]

export { render, staticRenderFns }